export const Colors = {
  dark: "dark",
  light: "light",
  darkBackground: "#202633",
  lightBackground: "#EEF5FF",
  darkBody: "#262E40",
  lightBody: "#F9FAFD",
  darkText: "#FFFFFF",
  lightText: "#000000",
  buttonTextDark: "#FF4F59",
  buttonTextLight: "#2B6FD6",
  modalHeaderDark: "#1D5F70",
  modalHeaderLight: "#CADCF8",
  deleteButtonColor: "#FF4F59",
  successColorDark: "#01f1ff",
  successColorLight: "#2B6FD6",
  darkBorder: "#444444",
  lightBorder: "#D9D9D9",
  uploadButtonDisableTextDark: "#999999",
  uploadButtonDisableTextLight: "#515866",
  uploadButtonDisableDark: "#7a7a7a",
  uploadButtonDisableLight: "#BEC0C6",
};
